// extracted by mini-css-extract-plugin
module.exports = {"panelPadding":"AdvertiserView_panelPadding__3Xgsu"};